import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_di01cyuf: FaireBrandEntity = {
  token: "b_di01cyuf",
  type: "brand",
  name: "Lovoda",
  avatarUrl:
    "https://cdn.faire.com/fastly/1e922df4570405d810104fae58dfe449dc3a7bd72f19a8be8413c0e69c32b807.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d4ce59c35f9e238cbc1c638a426c1e632d39710468abc89bb2ef8b878d8730dd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1e922df4570405d810104fae58dfe449dc3a7bd72f19a8be8413c0e69c32b807.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d4ce59c35f9e238cbc1c638a426c1e632d39710468abc89bb2ef8b878d8730dd.jpeg",
  location: "Hanover, MD, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 19,
  isInsider: true,
  description:
    "Lovoda began as a small jewelry shop in Baltimore, MD in 2014. Since then, Lovoda has grown into a brand that thrives on providing Jewelry that is stunning, high quality, and timeless to you! We believe that accessories are the final touch to complete any look. So we are here every step of the way to ensure the best pieces are matched. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:37.784Z",
    importedBy: "entity-db-cli",
  },
};
